import axios from "axios";
import { getUserAuth } from "../helpers";

export const BASE_URL = process.env["REACT_APP_SERVER_URL"];

export const OTHER_USER_ACCESS_SUB_DOMAIN =
  process.env["REACT_APP_OTHER_USER_ACCESS_DOMAIN"];

export const api = axios.create({
  baseURL: process.env["REACT_APP_SERVER_URL"],
});

export const imageApi = axios.create({
  baseURL: process.env["REACT_APP_IMAGE_BASE_URL"],
});

export const baseAxios = axios.create({
  baseURL: process.env["REACT_APP_SERVER_URL"],
});

/* ------------------------------------------------------------------ */
/* State */
/* ------------------------------------------------------------------ */

let isAlertShown = false;

/* ------------------------------------------------------------------ */
/* Helpers */
/* ------------------------------------------------------------------ */

const clearSessionAndRedirect = (url: string, message?: string) => {
  if (isAlertShown) return;

  isAlertShown = true;
  localStorage.clear();

  if (message) {
    window.alert(message);
  }

  window.location.href = url;
};

// Check if already on error pages to prevent infinite redirect loops
const isOnErrorPage = (): boolean => {
  const path = window.location.pathname;
  return [
    "/company-not-assigned",
    "/subscription-error",
    "/subscription-billing",
    "/auth/login",
  ].some((route) => path.includes(route));
};

const handleSubscriptionRedirect = (code: string) => {
  if (isAlertShown || isOnErrorPage()) return;
  isAlertShown = true;
  // window.location.href = `/subscription-billing?code=${code}`;
  window.history.replaceState(null, "", `/subscription-billing?code=${code}`);
  window.dispatchEvent(new PopStateEvent("popstate"));
};

/* ------------------------------------------------------------------ */
/* Request Interceptor */
/* ------------------------------------------------------------------ */
api.interceptors.request.use((config) => {
  const accessToken = getUserAuth();
  if (accessToken && config.headers) {
    config.headers["auth-Token"] = `${accessToken}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    const { data } = response;
    // Logical 401 returned as success:false
    if (data?.success === false && data?.code === "401") {
      if (!isOnErrorPage()) {
        clearSessionAndRedirect("/company-not-assigned?code=401");
      }
      return Promise.reject(data);
    }
    return response;
  },
  (error) => {
    console.error("API auto logout Error:", error);

    const status = error.response?.status;
    const errorData = error.response?.data;

    if (status === 401) {
      if (errorData?.message === 403 && errorData?.data?.includes("limit")) {
        return Promise.reject(error);
      }

      clearSessionAndRedirect(
        "/auth/login",
        "Attention: Your session has expired. Please log in again to continue."
      );
    }

    const code = error.response?.data?.code;

    /* ---------------- Subscription Errors -------------- */
    if (["402", "403", "406"].includes(code)) {
      handleSubscriptionRedirect(code);
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export const SUBSCRIPTION_ERROR_MESSAGE = {
  402: "Your subscription has expired.Renew now to continue uninterrupted service.",
  403: "Your subscription plan has expired! Please renew your subscription.",
  406: "This feature is available on higher plans. Please upgrade your subscription to continue.",
};
